export default {
    namespaced: true,
    state: () => ({
        filterPanelState: false,
        region: null,
        electionPart: null,
        tableOptions:
        {
            page: 1,
            itemsPerPage : 25,
            sortBy : [ "fullName" ],
            sortDesc : [ false ],
            groupBy : [],
            groupDesc : [],
            multiSort : false,
            mustSort : true
        },
        extendedFilter: null
    }),
    mutations: {
        SET_FILTER_PANEL_STATE(state, payload) {
            state.filterPanelState = payload;
        },
        SET_REGION(state, payload) {
            state.region = payload;
        },
        SET_ELECTION_PART(state, payload) {
            state.electionPart = payload;
        },
        SET_TABLE_OPTION(state, payload) {
            state.tableOptions = payload;
        },
        SET_TABLE_OPTION_PAGE(state, payload) {
            state.tableOptions.page = payload;
        },
        SET_EXTENDED_FILTER(state, payload) {
            state.extendedFilter = payload;
        },
    },
    getters: {
        getFilterPanelState: (s) => s.filterPanelState,
        getRegion: (s) => s.region,
        getElectionPart: (s) => s.electionPart,
        getTableOptions: (s) => s.tableOptions,
        getExtendedFilter: (s) => s.extendedFilter,
    }
}